/** 顯示格式化工具。 */

import type { Locale } from './i18n';

/** 由多語 map 依 locale 取字串；缺對應語言時 fallback 至任一可用值或 fallback。 */
export function pickI18n(
  map: Record<string, string> | null | undefined,
  fallback: string,
  locale: Locale,
): string {
  if (!map) return fallback;
  const candidates =
    locale === 'zh-TW'
      ? ['zh-TW', 'zh-Hant', 'zh']
      : locale === 'en'
        ? ['en', 'en-US']
        : ['ja', 'ja-JP'];
  for (const c of candidates) {
    if (map[c]) return map[c];
  }
  const first = Object.values(map)[0];
  return first ?? fallback;
}

/** NT$ 金額格式（吃 numeric string 或 number）。 */
export function formatPrice(value: string | number, currency = 'TWD'): string {
  const n = typeof value === 'string' ? Number(value) : value;
  if (!Number.isFinite(n)) return String(value);
  const symbol = currency === 'TWD' ? 'NT$' : `${currency} `;
  return `${symbol}${Math.round(n).toLocaleString('en-US')}`;
}

/** ISO 時間戳 → HH:MM（依機台所在時區）。 */
export function formatTime(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleTimeString('zh-TW', { hour: '2-digit', minute: '2-digit', hour12: false });
}

/** ISO 時間戳 → YYYY-MM-DD。 */
export function formatDate(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString('en-CA');
}
